import React, { useState } from 'react';
import {withStyles} from "@material-ui/core";
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import CourseGrid from "../../components/Courses/CourseGrid";
import Toolbar from "../../components/Toolbar/Toolbar";
import Table from "@material-ui/core/Table/Table";
import axios from "axios/index";
import Grid from "@material-ui/core/Grid/Grid";
import MediaSearchField from "../../components/Media/SearchField";
import FileUploadForm from "../../components/Uploader/FileUploadForm";

import {
    withPaginator,
    Pagination
} from '../../components/Pagination';

const CoursesIndex = ({classes, items}) => {
    // debugger;
    const [courses, setCourses] = useState(items);
    const [paginate, setPaginate] = useState(true);
    const CancelToken = axios.CancelToken;
    let cancel;

    const doSearch = (searchString) => {
        cancel && cancel();

        axios.get('/search-course', {
            params: {'query': searchString},
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
            })
        }).then((response) => {
            setPaginate(false);
            if (response.data && response.data.length > 0) {
                setCourses(response.data.map(item => item.entity));
            } else {
                setCourses([]);
            }
        })
    };

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('courses.heading_course')}
                // subtitle={`${courses.length} ${i18n.get('courses.number_of_course')}`}
                items={[
                    // {
                    //     icon: 'cloud_upload',
                    //     text: i18n.get('courses.import_courses'),
                    //     href: `/importers/courses`,
                    // },
                    {
                        icon: 'add',
                        text: i18n.get('courses.new_course'),
                        href: `/courses/create`,
                    }
                ]}
            />

            <Grid container justify="space-between" alignItems="center">
                <Grid item xs={4}>
                    <MediaSearchField
                        searchByTyping={true}
                        doSearch={doSearch}
                        label={i18n.get('default.search_course')}
                    />
                </Grid>
                <Grid item xs={3}>
                    {paginate && (
                        <Table>
                            <Pagination
                                colSpan={1}
                            />
                        </Table>
                    )}
                </Grid>
            </Grid>

            <CourseGrid courses={courses}/>

            {paginate &&
            <Table>
                <Pagination
                    colSpan={1}
                />
            </Table>
            }

            <Grid container>
                <Grid item xs={6}>
                    <FileUploadForm accept='.csv' lang={'participations.import_participations'} route={'/importers/participations'}/>
                </Grid>
                <Grid item xs={6}>
                    <FileUploadForm accept='.csv' lang={'schedules.import_schedules'} route={'/importers/schedules'}/>
                </Grid>
            </Grid>

        </Layout>
    )
};

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(withPaginator('pagination')(CoursesIndex));



// WEBPACK FOOTER //
// ./resources/assets/js/pages/courses/Index.jsx